/**
 * Filter-Achsen-Kodierung (Spec 409) — FE-Spiegel des BFF-Parsers
 * (`src/services/transactions-filter/transactions-filter.ts::parseFilterAxis`).
 *
 * Eine Achse `{ include, exclude }` wird als komma-getrennte `+/-`-Liste kodiert
 * (include → `+wert`, exclude → `-wert`) und so in URL/Query transportiert. Der BFF
 * liest dieselbe Form. Round-trip-sicher fuer die Wertdomaenen dieses Projekts
 * (serviceId, Status-/Operator-Enums) — keine enthalten `+`, `-` oder `,`.
 */

export interface FilterAxisValue {
  include: string[];
  exclude: string[];
}

export const EMPTY_FILTER_AXIS: FilterAxisValue = { include: [], exclude: [] };

export function isAxisActive(axis: FilterAxisValue): boolean {
  return axis.include.length > 0 || axis.exclude.length > 0;
}

/** Achse → `+a,+b,-c` (oder undefined, wenn leer → Param entfaellt). */
export function encodeFilterAxis(axis: FilterAxisValue): string | undefined {
  const parts = [...axis.include.map((v) => `+${v}`), ...axis.exclude.map((v) => `-${v}`)];
  return parts.length > 0 ? parts.join(',') : undefined;
}

/** `+a,-b` / `a` (bare = include, Legacy) → Achse. Trim, dedup, exclude gewinnt. */
export function decodeFilterAxis(raw: string | null | undefined): FilterAxisValue {
  const include: string[] = [];
  const exclude: string[] = [];
  if (!raw) return { include, exclude };

  for (const token of raw.split(',')) {
    const trimmed = token.trim();
    if (!trimmed) continue;
    if (trimmed.startsWith('-')) {
      const v = trimmed.slice(1).trim();
      if (v && !exclude.includes(v)) exclude.push(v);
    } else {
      const v = trimmed.startsWith('+') ? trimmed.slice(1).trim() : trimmed;
      if (v && !include.includes(v)) include.push(v);
    }
  }

  const excludeSet = new Set(exclude);
  return { include: include.filter((v) => !excludeSet.has(v)), exclude };
}
